import React, { useEffect, useMemo, useRef, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { createPost, sendFeaturedImage, updatePost } from "../../../../service/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import WordpressUploader from "../../../../components/CustomUpload/WordpressUploader";
import { Button, Input, Modal, Spin } from "antd";
import { CheckOutlined, CloseOutlined, PictureOutlined } from "@ant-design/icons";
import {  useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import AgroyaarTypography from "../../../../icons/agroyaar.png"
import { toast } from "react-toastify";

export default function Article() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryClient = useQueryClient()

  const Types = {
    FeaturedImage: "featuredImage",
    InlineImage: "inlineImage",
  };
  const quillRef = useRef();
  const [postData, setPostData] = useState(null);
  const [isNewPost, setIsNewPost] = useState(true);
  const [openUploader, setOpenUploader] = useState(false);
  const [featuredImageKey, setFeaturedImageKey] = useState("");
  const [inEditorImageKey, setInEditorImageKey] = useState("");
  const [type, setType] = useState("");
  const createPostMutation = useMutation(createPost);
  const updatePostMutation = useMutation(updatePost);



  useEffect(() => {
    if (location?.state) {
      setPostData(JSON.parse(location?.state?.articleData));
      setIsNewPost(false)
    }
  }, [location?.state]);

  const imageHandler = (type) => {
    setType(type);
    setOpenUploader(true);
  };

  const insertImageToEditor = () => {
    if (inEditorImageKey !== "") {
      const editor = quillRef.current.getEditor();
      editor.focus();
      const range = editor.getSelection();
      editor.insertEmbed(
        range.index,
        "image",
        process.env.REACT_APP_ARVAN_S3_BASE_URL + "agrouploads/" + inEditorImageKey
      );
      setOpenUploader(false);
    }
  };

  const setFeaturedImage = () => {
    if(featuredImageKey !== "") {
      setOpenUploader(false);
    }
  };

  const publishPostAsDraft = () => {
    if(postData?.title && postData?.content && featuredImageKey) {
      createPostMutation.mutate(postData, {
        onSuccess:() => {
          navigate('/content-management')
          queryClient.invalidateQueries(['expertArticles'])
        }
      });
    } else {
      toast.error('عنوان، متن و تصویر شاخص الزامی است')
    }
  };

  const updatePostAsDraft = () => {
    updatePostMutation.mutate({ postData: postData, id: postData?.id }, {
      onSuccess:() => {
        navigate('/content-management')
        queryClient.invalidateQueries(['expertArticles'])
      }
    });
  };

  const modules = useMemo(() => {
    return {
      toolbar: {
        handlers: {
          image: () => imageHandler(Types.InlineImage),
        },
        container: [
          [{ header: [1, 2, false] }],
          ["bold", "italic", "underline", "strike", "blockquote"],
          [
            { list: "ordered" },
            { list: "bullet" },
            { indent: "-1" },
            { indent: "+1" },
          ],
          ["link", "image"],
          ["clean"],
        ],
      },
      clipboard: {
        matchVisual: false,
      },
    };
  }, []);

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
  ];

  return (
    <div className="flex flex-row font-body justify-between gap-3 p-4 h-[88vh]
    max-lg:flex-col-reverse max-lg:h-full">
      {((location?.state && postData) || (!location?.state)) ? (
        <>
          <section className="flex flex-col max-lg:w-full w-2/3 bg-white p-4 rounded-lg gap-4">
            <div className="flex flex-row justify-start items-center gap-4 
            max-lg:flex-col max-lg:items-start">
              <label className="font-body whitespace-nowrap">عنوان مقاله</label>
              <Input
                className="w-2/3 max-lg:w-full"
                placeholder="عنوان مقاله را وارد کنید"
                onChange={(e) =>
                  setPostData({ ...postData, title: e?.target?.value })
                }
                defaultValue={postData?.title}
              />
            </div>

            <div className="flex flex-row justify-start gap-4 h-5/6 
            max-lg:flex-col max-lg:items-start">
              <label className="font-body whitespace-nowrap">متن مقاله</label>
              <ReactQuill
                ref={quillRef}
                className="bg-white rounded-lg h-full"
                defaultValue={postData?.content}
                modules={modules}
                formats={formats}
                onChange={(value) =>
                  setPostData({ ...postData, content: value })
                }
              />
            </div>
            {!true && <Button className="bg-gradient-to-r from-blue-800 to-sky-600 text-white lg:w-1/2 lg:m-auto"
            onClick={() => navigate('comments')}>
            مشاهده نظرات
            </Button>}
            {/* <Link
              className="bg-green-600 py-2 px-4 w-fit rounded-lg font-body"
              // navigate()
              to={{
                pathname: "comments",
                search: `?postId=${postData?.id}`,
              }}
            >
              مشاهده نظرات
            </Link> */}
          </section>

          <section className="flex flex-col w-1/3 gap-4
          max-lg:flex-row max-lg:w-full">
            <div className="flex flex-col bg-white items-start !w-full h-1/3 p-4 rounded-lg
            max-lg:!h-[300px]">
              <label className="text-lg font-bold">انتشار</label>
              <span class="h-[1px] w-full bg-gray-300 px-5" />
              <p className="text-sm mt-4">
                وضعیت: <span className="font-bold">{postData?.status ? postData?.status : '------'}</span>
          
              </p>
              <span class="h-[1px] w-full bg-gray-300 px-5 mt-auto" />
              <div className="flex flex-row w-full justify-between mt-4">
                {/* <p className="w-20 py-2 rounded-lg text-red-600 underline text-start">
                  {createPostMutation.isLoading ? "لطفا ..." : "بایگانی"}
                </p> */}
                <Button
                  className="w-20 py-2 rounded-lg font-body flex justify-center items-center"
                  loading={createPostMutation?.isLoading || updatePostMutation?.isLoading}
                  onClick={location?.state ? updatePostAsDraft : publishPostAsDraft}
                >
                {`${location?.state ? 'به روزرسانی' : 'انتشار'}`}
                </Button>
              </div>
            </div>
            <div className="flex flex-col bg-white items-center w-full h-2/3 p-4 rounded-lg gap-7
            max-lg:max-lg:!h-[300px]">
              <label className="text-lg font-bold self-start">تصویر شاخص</label>
              {(featuredImageKey !== "" || postData?.featuredImage) && <img
                className="w-[300px] h-[100px] rounded-lg max-lg:w-full"
                alt="featuredImage"
                src={ featuredImageKey || postData?.featuredImage }
              />}
              <div
                className="cursor-pointer border-[1px] px-4 rounded-lg border-dashed border-gray-500"
                onClick={() => imageHandler(Types.FeaturedImage)}
              >
                <PictureOutlined className="text-6xl text-[#7F7F7F]" />
                <p className="text-center font-body text-xs">{`${location?.state ? 'تغییر' : 'انتخاب'}`}</p>
              </div>
            </div>
          </section>
        </>
      ) : (
        <Spin spinning={true} />
      )}
      {openUploader && (
        <Modal
          okText="انتخاب"
          cancelText="لغو"
          open={openUploader}
          title="انتخاب تصویر"
          onOk={
            type === Types.FeaturedImage
              ? setFeaturedImage
              : insertImageToEditor
          }
          okButtonProps={{
            type: "primary",
            ghost: false,
            icon: <CheckOutlined/>,
            style: { backgroundColor: "#005AC8", fontFamily: "IRANSansX" },
          }}
          cancelButtonProps={{
            type: "primary",
            ghost: false,
            icon: <CloseOutlined />,
            style: { backgroundColor: "#B8083D", fontFamily: "IRANSansX" },
          }}
          onCancel={() => setOpenUploader(false)}
        >
          <WordpressUploader type={type} setFeaturedImageKey={setFeaturedImageKey}  setInEditorImageKey={setInEditorImageKey} postData={postData} setPostData={setPostData} setOpenUploader={setOpenUploader}/>
        </Modal>
      )}
    </div>
  );
}

